module.exports = __webpack_public_path__ + "ffc72c038f6680e96b52c9e450eca522.pdf";